'use client';

import { Typography } from '@musinsa/mds';
import { twMerge } from 'tailwind-merge';
import { useCountdown } from '../hooks/useCountdown';

interface CountdownHeaderProps {
  /** 본문 라벨 (예: "콘텐츠 등록까지 남은 시간") */
  label: string;
  /** 카운트다운 종료 시각 (ms epoch). */
  targetAt: number | null;
  /** 마감 경과 시 label·카운트다운 대신 노출할 텍스트 (예: "콘텐츠 제출 기한 경과"). (SID-4178 작업2) */
  expiredLabel?: string | null;
  onExpire?: () => void;
  className?: string;
}

/**
 * delivered / contentRegistered / pending / soldOut 등의 본문 최상단 H1 자리.
 * label (좌) + countdown (우, blue) 한 줄. typography: `title18pxMed` (Figma 확정 — H1 자리도 18px Medium).
 *
 * `CampaignInfo.Container` 안에서 사용 — Container 가 padding 책임지므로 자체 padding 없음.
 */
export const CountdownHeader = ({
  label,
  targetAt,
  expiredLabel,
  onExpire,
  className,
}: CountdownHeaderProps) => {
  const countdown = useCountdown({ targetAt, onExpire });
  // 마감 경과 + expiredLabel 있으면 카운트다운 숨기고 경과 텍스트만 노출. (SID-4178 작업2)
  const showExpired = !!countdown?.isExpired && !!expiredLabel;
  return (
    <div className={twMerge('flex items-center', className)}>
      {/* 카운터를 타이틀 바로 우측(여백 없음)에 배치 — flex-1/gap 제거. (SID-4134) */}
      <Typography variant="title18pxMed" colorScheme="black">
        {showExpired ? expiredLabel : label}
      </Typography>
      {countdown && !showExpired && (
        // 라벨과 D-n 사이 한 칸 간격 — "남은 시간D-7" 처럼 붙던 문제 수정. (SID-4178)
        // SID-4134 가 제거한 건 flex-1/gap 의 큰 여백이고, 단어 사이 한 칸 공백은 유지한다.
        <Typography variant="title18pxMed" colorScheme="blue" className="ml-[4px]!">
          {countdown.text}
        </Typography>
      )}
    </div>
  );
};
